import { useSelector, TypedUseSelectorHook } from 'react-redux';

import { AppState } from 'types';

const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector;

export { useTypedSelector };
